import React, {useEffect} from "react"
import theme from "./../../../Theme/Theme"
import { Div, Text, Row, Col, Icon } from "atomize";
import styled from "styled-components";
import {apiGet} from "../../../Api";
import {baseUrl} from "../../../Constants/constants";
import Skeleton from "react-loading-skeleton";

const Wrapper = styled(Col)`
  margin-bottom: 1rem;
`;

const ItemDiv = styled(Div)`
  display: flex;
  border-radius: 8px;
  height: 100%;
  align-items: center;
  padding: 2rem;
  
  img {
    width: 100%;
  }
`;

function SupporterItem(props) {
  const supporter = props.supporter;
  const [data, setData] = React.useState({});

  useEffect(() => {
    async function fetchData() {
      const result = await apiGet(`file/file/${supporter.id}?jsonapi_include=1`);
      // console.log(result.data.data)
      setData(result.data.data);
    }

    fetchData();
  }, []);

  return (
    <Wrapper
      size={{ xs: '12', sm: '12', md: '4', lg: '4' }}
    >
      <ItemDiv>
        { data.uri &&
          <img alt={supporter.meta.alt ? supporter.meta.alt : data.filename } src={ baseUrl + data.uri.url} />
        }
        {
          !data.uri &&
          <Skeleton height={'4rem'}/>
        }
      </ItemDiv>
    </Wrapper>
  )
}

export default SupporterItem;
